export default {
    categoriasLp: new Array(),
    unidadesProcedenciaLP: [{cnes: '', nome: ''}],
    dadosPacienteLp: ''
}
